export default function DonateOptionSelectDialog({ isOpen, campaignID, setOpen, optionsAmount, campaign, setDonateSum }) {
    const doDonate = () => {

    };
    const changeDonateSum = (newSum = null) => {
        if (newSum === null) {
            newSum = document.getElementById('input-donate-sum').value;
            setDonateSum(newSum);
        } else {
            setDonateSum(newSum);
        }
    };
    const handleCloseDialog = () => {
        setOpen(false);
    };
    return (
        <>
            {
                isOpen ? (
                    <div id="popup-checks" class="popup _open">
                        <div class="popup__body">
                            <div class="popup__content">
                                <div class="popup__close" onClick={handleCloseDialog}>
                                    <img src="/img/sprite/close.svg" alt="" />
                                </div>
                                <div class="popup__head">
                                    <h2 class="popup__title ">Please choose donation sum!</h2>
                                </div>

                                <div className="box">
                                    <div className="box__top">
                                        <div className="box__title">Preset donation:</div>
                                    </div>
                                    <div className="box__body">
                                        <div className="donations">
                                            {optionsAmount?.map((optionsAmountItem, index) => (
                                                <div className="donations__item donations-card" onClick={() => changeDonateSum(optionsAmountItem.sum)}>
                                                    <div className="donations-card__img" style={{ 'background-image': 'url(' + optionsAmountItem?.image + ')' }}></div>
                                                    <div className="donations-card__content">
                                                        <div className="donations-card__title">{optionsAmountItem.title}</div>
                                                        <div className="donations-card__text">{optionsAmountItem.text}</div>
                                                        <div className="donations-card__donate"> Donate: {optionsAmountItem.sum}$</div>
                                                    </div>
                                                </div>
                                            ))}

                                            <div className="donations__input">
                                                <div className="donate-form">
                                                    <div className="donate-form__buttons">
                                                        <div className="donate-form__plus"></div>
                                                        <div className="donate-form__minus"></div>
                                                    </div>

                                                    <div className="donate-form__sel form-sel">
                                                        <div className="form-sel__button">$ USD</div>
                                                        <div className="form-sel__drop">
                                                            <div className="form-sel__drop-item">$ USD</div>
                                                            <div className="form-sel__drop-item">$ USD</div>
                                                        </div>
                                                    </div>
                                                    <input type="text" className="donate-form__input" onChange={changeDonateSum} id="input-donate-sum" />
                                                </div>
                                            </div>

                                            <div className="donations__button">
                                                <a className="btn btn--block" onClick={doDonate}>DONATE!</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                ) : ''
            }
        </>
    );
}
